import { render, staticRenderFns } from "./PosMana.vue?vue&type=template&id=1f2e0426"
import script from "./PosMana.vue?vue&type=script&lang=js"
export * from "./PosMana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports